import { FC } from 'react';
import { Box, TextField } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

export type Coordinates = {
  lat: number;
  lng: number;
};

interface SetupPreciseCoordsProps {
  coordinates?: Coordinates;
  onSetup: () => void;
  onReset: () => void;
  isSettingUp: boolean;
  isFetching?: boolean;
}

export const SetupPreciseCoords: FC<SetupPreciseCoordsProps> = ({
  coordinates,
  onSetup,
  onReset,
  isSettingUp,
  isFetching,
}) => {
  return (
    <Box display="flex" alignItems="center" gap="12px" width="100%">
      {!coordinates ? (
        <Button
          size="medium"
          color="secondary"
          disabled={isSettingUp || isFetching}
          onClick={onSetup}
          style={{ height: '40px' }}
        >
          {'Add pin'}
        </Button>
      ) : (
        <>
          <TextField
            disabled
            variant="outlined"
            value={`${coordinates.lat.toFixed(6)}, ${coordinates.lng.toFixed(6)}`}
            sx={{ width: '100%' }}
          />
          <Button size="medium" color="secondary" disabled={isSettingUp} onClick={onSetup} style={{ height: '40px' }}>
            {'Edit Pin'}
          </Button>
          <Button size="medium" color="tertiary" disabled={isSettingUp} onClick={onReset} style={{ height: '40px' }}>
            Reset
          </Button>
        </>
      )}
    </Box>
  );
};
